// extracted by mini-css-extract-plugin
export default {"servicesSubcategoryList":"FjKm70knkL87xjpCV0Kp","open":"A3bdeInXzvFrr4zEbZh7"};